#import "./quote-money-fragment.graphql"

fragment SubtotalLineItemFragment on QuoteSubtotalLineItemsConnection {
    totalCount
    edges {
        node {
            id
            price {
                ...QuoteMoneyFragment
            }
            label
            modifierUnit
            modifierValue
            formattedValue
            operation
        }
    }
}
